import { o as t, c as o, a as e } from "./core.0767a1be.js";
const s = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "none",
  viewBox: "0 0 20 20"
}, c = /* @__PURE__ */ e("circle", {
  cx: "10",
  cy: "10",
  r: "10",
  fill: "#4f8cf7",
  "fill-opacity": ".2",
  class: "text-base"
}, null, -1), l = /* @__PURE__ */ e("path", {
  stroke: "#4f8cf7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m6 10 3 3 5-5"
}, null, -1), n = [
  c,
  l
];
function r(a, i) {
  return t(), o("svg", s, n);
}
const f = { render: r };
export {
  f as default,
  r as render
};
//# sourceMappingURL=selected-cycle.50d96847.js.map
